import React, { FC } from 'react';
import classnames from 'classnames';
import { Props } from './props';
import './styles.scss';

export const Tabs: FC<Props> = ({ activeTab, className, tabs, onSelect }) => {
  return (
    <div className={classnames('tabs', className)}>
      {tabs.map(tab => (
        <div
          className={classnames('tab', activeTab.key === tab.key && 'active')}
          key={tab.key}
          onClick={() => onSelect(tab)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};
